module.exports = __webpack_public_path__ + "20db0aa89b9ae0d3a2f14814b174cfe5.png";